import { render } from "./accept_request.vue?vue&type=template&id=53a77682"
import script from "./accept_request.vue?vue&type=script&lang=js"
export * from "./accept_request.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__